// extracted by mini-css-extract-plugin
module.exports = {"navigateBtnCol":"oneWayInterviewConfiguration_navigateBtnCol__OiQ3f","dividerLine":"oneWayInterviewConfiguration_dividerLine__1h5lc"};